<div class="padding">
  <div class="box card-box m-x-sm shadow">
    <div class="box-header">
      <h3>{{ 'SDC.LOGS.admin' | translate }}</h3>
    </div>
    <div class="box-body">
      <gp-sdc-logs-list></gp-sdc-logs-list>
    </div>
  </div>
</div>
